// extracted by mini-css-extract-plugin
module.exports = {"top":"Template_top__2Cl7b","title":"Template_title__1s0oz","contentModal":"Template_contentModal__2eMFc","docPreviewContainer":"Template_docPreviewContainer__voNIf"};